<template>
  <div class="slider-button">
    <div class="swiper-button-prev" :class="name.prevEl" slot="button-prev">
      <svg width="27" height="15" viewBox="0 0 27 15" fill="none">
        <rect
          width="1.98052"
          height="24.6213"
          transform="matrix(-0.00338485 0.999994 -0.999995 -0.00331923 26.4004 6.15967)"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.1844 7.02761L8.8985 1.57421L7.5425 0.137733L0.399348 6.95498L1.75535 8.39145L1.75577 8.39106L7.1801 14.1373L8.60873 12.7738L3.1844 7.02761Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="swiper-button-next" :class="name.nextEl" slot="button-next">
      <svg width="27" height="15" viewBox="0 0 27 15" fill="none">
        <rect
          width="1.98052"
          height="24.6213"
          transform="matrix(-0.00338485 0.999994 -0.999995 -0.00331923 26.4004 6.15967)"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.1844 7.02761L8.8985 1.57421L7.5425 0.137733L0.399348 6.95498L1.75535 8.39145L1.75577 8.39106L7.1801 14.1373L8.60873 12.7738L3.1844 7.02761Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: Object,
    titles: Object,
  },
};
</script>
<style lang="scss" scoped>
.slider-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 2rem;
}
.swiper-button-prev,
.swiper-button-next {
  svg {
    rect,
    path {
      fill: #fff;
    }
  }
  &.blue {
    svg {
      path,
      rect {
        fill: #262262;
      }
    }
  }
  &.swiper-button-disabled {
    opacity: 0.5;
  }
}
.swiper-button-prev,
.prev,
.swiper-button-next,
.next {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: initial;
  width: 2.6rem;
  height: 1.4rem;
  background-image: none;
  background-size: cover;
  background-position: center;
  margin: 0;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  &.swiper-button-disabled {
    opacity: 1;
  }
  &:after,
  &:before {
    display: none;
  }
  &.slick-hidden {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    opacity: 0.5;
    cursor: initial;
  }
}
.swiper-button-prev,
.prev {
  margin-right: 2rem;
  &:hover {
    transform: translate(-5px, 0);
  }
  &.slick-hidden:hover {
    transform: none;
  }
}
.swiper-button-next,
.next {
  transform: rotate(-180deg);
  &:hover {
    transform: translate(5px, 0) rotate(-180deg);
  }
  &.slick-hidden:hover {
    transform: none;
    transform: rotate(-180deg);
  }
}
</style>